import { render, staticRenderFns } from "./IntegrationRequestSidebar.vue?vue&type=template&id=ccb3eb80&scoped=true"
import script from "./IntegrationRequestSidebar.vue?vue&type=script&lang=ts"
export * from "./IntegrationRequestSidebar.vue?vue&type=script&lang=ts"
import style0 from "./IntegrationRequestSidebar.vue?vue&type=style&index=0&id=ccb3eb80&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb3eb80",
  null
  
)

export default component.exports